import axios from "axios";
import constants from "../constants";
import { EventBus } from './event-bus.js';

export default {
    getLatestProcessDefinitions() {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/processEngine/customViewAPI/getLatestProcessDefinitions", {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process definitions"
                    });
                }
            });
    },
    getProcessvariablesForProcess(ProcessDefId) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/processEngine/customViewAPI/getVariablesByProcess/" + ProcessDefId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching process variables"
                    });
                }
            });
    },
    saveCustomView(customViewTask, customViewId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/processEngine/customViewAPI/saveCustomView/" + customViewId, customViewTask)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let notification = {
                    "msg": "Error"
                }
                EventBus.$emit('error-notification', notification);
            })
    },
    shareCustomView(customViewId, customViewShareDTO) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/processEngine/customViewAPI/share/" + customViewId, customViewShareDTO)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let notification = {
                    "msg": "Error"
                }
                EventBus.$emit('error-notification', notification);
            })
    },
    getCustomViewData(customViewId) {
        var msgType = "fetchSuccess";
        return axios.get(constants.BASE_URL + "/processEngine/customViewAPI/getVariablesPage/" + customViewId, {
            withCredentials: true
        })
            .then(response => {
                return response.data;
            })
            .catch(error => {
                msgType = "fetchError";
            })
            .finally(() => {
                if (msgType == 'fetchError') {
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching custom view data"
                    });
                }
            });
    },
    deleteCustomView(customViewId) {
        axios.defaults.withCredentials = true;

        return axios.post(constants.BASE_URL + "/processEngine/customViewAPI/deleteCustomView/" + customViewId)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                let notification = {
                    "msg": "Error"
                }
                EventBus.$emit('error-notification', notification);
            })
    }

}